import React from 'react'
import RenderRouter from './routes'

export function App(props) {
  return (
    <div className="app">
      <RenderRouter></RenderRouter>
    </div>
  )
}

export default App
